import React from 'react';

// The scoring platform's loading marks, reused here so the two feel like one product.
//
// A gold ring with one transparent quarter, spinning. `border-t-transparent` is what makes
// the rotation legible — a complete ring spinning looks static.

/** Inline: for a section that is still fetching, with the surrounding page already drawn. */
export default function LoadingSpinner({ message = 'Loading…' }) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-gold border-t-transparent" />
      {message && <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">{message}</p>}
    </div>
  );
}

/** Full screen: the app itself is deciding whether you are signed in.
 *
 * DEPARTURE from the platform this is copied from, which hardcodes a near-black backdrop
 * because it is dark by default. This portal defaults to light, so a literal copy would
 * flash a black screen on every load before the app painted. Same mark, theme-aware ground.
 */
export function FullPageSpinner() {
  return (
    <div className="flex h-screen items-center justify-center bg-white dark:bg-gray-950">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-gold border-t-transparent" />
    </div>
  );
}
